import React from 'react';

const PinIcon: React.FC = () => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="25" height="24" viewBox="0 0 25 24" fill="none">
      <path
        d="M12 11.5C13.6569 11.5 15 10.1569 15 8.5C15 6.84315 13.6569 5.5 12 5.5C10.3431 5.5 9 6.84315 9 8.5C9 10.1569 10.3431 11.5 12 11.5Z"
        stroke="#808080"
        strokeMiterlimit="10"
      />
      <path
        d="M19 8.5C19 6.64348 18.2625 4.86301 16.9497 3.55025C15.637 2.2375 13.8565 1.5 12 1.5C10.1435 1.5 8.36301 2.2375 7.05025 3.55025C5.7375 4.86301 5 6.64348 5 8.5C5 12.366 12 22.5 12 22.5C12 22.5 19 12.366 19 8.5Z"
        stroke="#808080"
        strokeMiterlimit="10"
      />
    </svg>
  );
};

export default PinIcon;
